import { Box, Button, CircularProgress, Divider } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import useQueryState from "../../hooks/useQueryState";
import useTimeseriesFinancial from "../../hooks/useTimeseriesFinancial";

const ACTION_BUTTON_TEXT: Record<string, [string, string]> = {
  "/home": ["Go to User Guide", "Start Dashboard"],
  "/disclaimer": ["", "Get Started"],
  "/dashboard/financial-indices": ["Back", "Download"],
};

const DASHBOARD_ROUTES = [
  "/dashboard/get-started",
  "/dashboard/drought-risk",
  "/dashboard/drought-indices",
  "/dashboard/financial-indices",
] as const;

const Footer = () => {
  const { pathname, search } = useLocation();
  const {
    queryState: { payout },
  } = useQueryState();
  const {
    postFinancialTimeseries: { data, isLoading },
    downloadFinancialPayout,
  } = useTimeseriesFinancial({ enabled: false });
  const navigate = useNavigate();

  const isHomePage = pathname === "/home";
  const isDisclaimerPage = pathname === "/disclaimer";

  const dashboardIndex = DASHBOARD_ROUTES.findIndex((route) =>
    pathname.startsWith(route),
  );
  const isDashboardLast =
    dashboardIndex === DASHBOARD_ROUTES.length - 1 && dashboardIndex !== -1;

  const [startLabel, endLabel] = ACTION_BUTTON_TEXT[pathname] ?? [
    "Back",
    "Next",
  ];

  const commonButtonWidth = {
    width: {
      lg: isHomePage ? "225px" : "120px",
      xl: isHomePage ? "257px" : "120px",
    },
  } as const;

  const handleNext = async () => {
    if (isHomePage || isDisclaimerPage) {
      return navigate({
        pathname: "/dashboard/get-started",
        search,
      });
    }

    if (dashboardIndex > -1 && !isDashboardLast) {
      return navigate({
        pathname: DASHBOARD_ROUTES[dashboardIndex + 1],
        search,
      });
    }

    if (isDashboardLast) {
      await downloadFinancialPayout.mutateAsync();
    }
  };

  const handlePrevious = () => {
    if (isHomePage) {
      navigate({
        pathname: "/disclaimer",
        search,
      });
      return;
    }

    if (dashboardIndex === 0) {
      navigate({
        pathname: "/home",
        search,
      });
    }

    if (dashboardIndex > 0) {
      navigate({
        pathname: DASHBOARD_ROUTES[dashboardIndex - 1],
        search,
      });
    }
  };

  return (
    <Box
      sx={{
        bottom: 0,
        backgroundColor: "white",
      }}
    >
      <Divider />
      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "center",
          paddingY: "15px",
          gap: 1,
        }}
      >
        {!isDisclaimerPage && (
          <Button
            variant="outlined"
            sx={{
              borderColor: "#2D3648",
              textTransform: "none",
              color: "#2D3648",
              ...commonButtonWidth,
            }}
            onClick={handlePrevious}
            // disabled={isDashboardFirst || isDisclaimerPage}
          >
            {startLabel}
          </Button>
        )}

        <Button
          variant="contained"
          color="primary"
          onClick={handleNext}
          disabled={
            endLabel === "Download" && downloadFinancialPayout.isLoading
          }
          sx={{
            backgroundColor: "#2D3648",
            textTransform: "none",
            ...commonButtonWidth,
          }}
        >
          {downloadFinancialPayout.isLoading && endLabel === "Download" ? (
            <CircularProgress size={20} sx={{ color: "white" }} />
          ) : (
            endLabel
          )}
        </Button>
      </Box>
    </Box>
  );
};

export default Footer;
